var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalRouteChild',{attrs:{"small":"","parent":_vm.parent}},[_c('SectionTitle',{attrs:{"title":_vm.config.POSTPONE_TITLE}}),_c('SectionPicture',[_c('ArtPostpone',{attrs:{"color":_vm.config.COLOR_PRIMARY}})],1),_c('SectionText',{attrs:{"text":_vm.config.POSTPONE_DESCRIPTION}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }